import formatProductsData from './format-products-data-shopify';
import fieldsRequest from './fields-request';
import loadProductsByCollection from '../../core/storefrontAPI/load-products-by-collection';
import withTimeout from '../../core/withTimeout';

// The Storefront fetch has no timeout of its own, so a stalled connection would hang the grid
const SHOPIFY_REQUEST_TIMEOUT = 10000;

const REQUEST_FAILED = Symbol('request-failed');

/*
This fallback class is used to handle Shopify collections in case Nosto data has issues
Important: also update the NostoCollections class in collections.js if editing this one
*/
export default class ShopifyCollection {
  collection_id;
  fields;

  constructor(collection_id) {
    this.collection_id = collection_id;
    this.fields = fieldsRequest;

    window.theme.collections.filtering = [];
    window.theme.collections.sorting = 'manual';
  }

  /**
   * Make Shopify Storefront API request
   * Doesn't apply to search overlay
   *
   * Note: the ambassador tag built into `excludeTags` here, and the combined_product parent exclusion, are both
   * filtered out client-side inside loadProductsByCollection after the response comes back, since the Storefront
   * API's ProductFilter has no negation support (no "not"/tagNot, and no metafield "not equal" field). This means
   * a page can render with fewer than products_per_page items, and cursor-based paging can skip/duplicate
   * boundary items when excluded products fall on a page edge.
   *
   * Always settles: resolves to null if the request fails or doesn't answer in time, which the
   * callers render as a retryable failure rather than as an empty collection.
   *
   * @returns {Promise<Object|null>} Formatted products data, or null if the request failed
   */
  shopifyRequest = async () => {
    try {
      // Drop sold out products server-side so they don't count against products_per_page
      const filters = [{ available: true }];

      // Enforce plus size-only products on plus size collections
      if (document.querySelector('[data-collection-grid]')?.dataset?.plus === 'true') {
        filters.push({ variantMetafield: { namespace: 'astr', key: 'plus_size', value: 'true' } });
      }

      // Hide ambassaor products if not on the ambassador collection
      // Hide ambassaor products on the ambassador collection but the user is not an ambassador (in case someone hacks the redirect from the collection page)
      let excludeTags = [];
      if ((window.theme.collections.current === 'ambassador' && !window.theme.customer.ambassador) || window.theme.collections.current !== 'ambassador') {
        excludeTags = ['ambassador', 'combined::parent'];
      }

      console.log('[ASTR] filters', filters, 'excludeTags', excludeTags);
      console.log('[ASTR] products_per_page: ', window.theme.collections.products_per_page, ' page: ', window.theme.collections.page);

      const response = await withTimeout(
        loadProductsByCollection(window.theme.collections.current_id, '', filters, excludeTags),
        { ms: SHOPIFY_REQUEST_TIMEOUT, fallback: REQUEST_FAILED, label: 'Shopify collection request' }
      );

      if (response === REQUEST_FAILED) {
        return null;
      }

      return formatProductsData(response);
    } catch (error) {
      console.log('ShopifyCollection Error', error);
      return null;
    }
  };
}
